import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  SapRoles,
  roleTypeGroup,
  roleTypeOperator,
  roleTypeSap,
} from "src/_constants/roleType";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { BetConfigReqParams, HoldReportReq, HoldReportResp } from "src/_models";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class AppService {
  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));

  public ForOP = roleTypeOperator.includes(this.userInfo.role);
  public ForSAP = roleTypeSap.includes(this.userInfo.role);
  public ForRolex = this.userInfo.role === 'RolexAdmin';
  public ForGA = roleTypeGroup.includes(this.userInfo.role);
  public MainUsers = ["runmatrix"]
  public NmUsers = ["nmsap"].concat(this.MainUsers);
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
    }),
  };
  public httpOptions2 = {
    headers: new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
    }),
  };
  public testCasesResult: Subject<any> = new Subject();
  private selectedProvider;
  private selectedSport;
  private selectedCompetiton;
  private selectedMarket;

  constructor(private http: HttpClient, private _snackBar: MatSnackBar) {}

  openSuccessBar(msg: string) {
    this._snackBar.open(msg, "close", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["green-snackbar"],
    });
  }

  openErrorBar(msg: string) {
    this._snackBar.open(msg, "close", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["red-snackbar"],
    });
  }

  getUsers(page, number,status, query?: string) {
    if (this.NmUsers.includes(this.userInfo.userId) || this.ForGA) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-portal-user`,
        { page: 0, pageSize: 0, partialUserName: query },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/get-users`,
        { page: page, pageSize: number, partialUserName: query,status:status },
        this.httpOptions
      );
    }
  }

  getOperatorUsers(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/get-users`,
      data,
      this.httpOptions
    );
  }

  getOperators(query: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-portal-user`,
        { pageSize: 25, searchKey: query },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/get-operators-list`,
        {
          // Page: page,
          // Number: number,
        },
        this.httpOptions
      );
    }
  }

  getProviders() {
    return this.http.post<any>(
      `${environment.apiUrl}/get-providers`,
      null,
      this.httpOptions
    );
  }

  getUserOperations() {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-user-operations`,
      null,
      this.httpOptions
    );
  }

  getGames(page = 1, number = 10) {
    return this.http.post<any>(
      `${environment.apiUrl}/get-games-list`,
      {
        Page: page,
        Number: number,
      },
      this.httpOptions
    );
  }

  getTestCases(providerId, walletType) {
    return this.http.post<any>(
      `${environment.apiUrl1}/test/get-test-cases`,
      { providerId, walletType },
      this.httpOptions
    );
  }

  getTestCasesResult(OpertorId, ProviderId, UserId, UserToken, testCases) {
    return this.http.post<any>(
      `${environment.apiUrl1}/test/get-test-cases-results`,
      {
        operatorId: OpertorId,
        providerId: ProviderId,
        userId: UserId,
        token: UserToken,
        testCases,
      },
      this.httpOptions
    );
  }

  blockProvider(pid: string, partnerId: string, oid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/block-saprovider`,
        { ProviderId: pid, PartnerId: partnerId },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/block-oaprovider`,
        { ProviderId: pid, PartnerId: partnerId, OperatorId: oid },
        this.httpOptions
      );
    }
  }
  unBlockProvider(pid: string, partnerId: string, oid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/unblock-saprovider`,
        { ProviderId: pid, PartnerId: partnerId },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/unblock-oaprovider`,
        { ProviderId: pid, PartnerId: partnerId, OperatorId: oid },
        this.httpOptions
      );
    }
  }

  blockOperator(data: { providerId: string }) {
    return this.http.post<any>(
      `${environment.apiUrl}/block-operator`,
      data,
      this.httpOptions
    );
  }

  unBlockOperator(data: { providerId: string }) {
    return this.http.post<any>(
      `${environment.apiUrl}/unblock-operator`,
      data,
      this.httpOptions
    );
  }

  blockUser(uid: string, oid: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/block-user`,
      { userId: uid, operatorId: oid },
      this.httpOptions
    );
  }

  unBlockUser(uid: string, oid: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/unblock-user`,
      { userId: uid, operatorId: oid },
      this.httpOptions
    );
  }

  assignUserLimit(uid: string, oid: string, limitId: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/assign-user-limit`,
      { userId: uid, operatorId: oid, limitId: limitId },
      this.httpOptions
    );
  }

  blockPortalUser(userKey: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/block-portal-user`,
      { userKey: userKey },
      this.httpOptions
    );
  }

  unBlockPortalUser(userKey: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/unblock-portal-user`,
      { userKey: userKey },
      this.httpOptions
    );
  }

  blockGames(data: { provider_name: string; game_id: string }) {
    return this.http.post<any>(
      `${environment.apiUrl}/block-game`,
      data,
      this.httpOptions
    );
  }

  unBlockGames(data: { provider_name: string; game_id: string }) {
    return this.http.post<any>(
      `${environment.apiUrl}/unblock-game`,
      data,
      this.httpOptions
    );
  }

  getBetList(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-bet-list`,
      {
        userName: filters.userName,
        userId: filters.userId,
        operatorId: filters.operatorId,
        status: filters.status,
        sportIds: filters.sportIds,
        eventId: filters.eventId,
        marketId: filters.marketId,
        startTime: filters.startTime,
        endTime: filters.endTime,
        transactionId: filters.transactionId,
        ip: filters.ip,
        providerId: filters.providerId,
        PageSize: filters.PageSize,
        Page: filters.Page,
        origin: filters.origin,
        category: filters.category,
      },
      this.httpOptions
    );
  }

  saveFilters(page: string, filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/save-filters`,
      { page, filters },
      this.httpOptions
    );
  }

  getFilters(page: string) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-filters`,
      { page },
      this.httpOptions
    );
  }

  getuserPlData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-users-pnl-report`,
      {
        profitLossOrder: filters.profitLossOrder,
        betCountOrder: filters.betCountOrder,
        operators: filters.operatorId,
        sportId: filters.sportId,
        origin: filters.origin,
        startTime: filters.startTime,
        endTime: filters.endTime,
        providerId: filters.providerId,
        userId : filters.userId,
        // sportName: filters.sportName,
        PageSize: filters.PageSize,
        Page: filters.Page,
      },
      this.httpOptions
    );
  }
  getExportExcel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-bet-list-excel`,
      {
        userName: filters.userName,
        userId: filters.userId,
        operatorId: filters.operatorId,
        status: filters.status,
        eventId: filters.eventId,
        marketId: filters.marketId,
        sportIds: filters.sportIds,
        startTime: filters.startTime,
        endTime: filters.endTime,
        providerId: filters.providerId,
        origin: filters.origin,
        category: filters.category,
      },
      this.httpOptions
    );
  }
  getPLExportExcel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-users-pnl-report-excel`,
      {
        operators: filters.operatorId,
        sportId: filters.sportId,
        startTime: filters.startTime,
        endTime: filters.endTime,
        userId : filters.userId,
        origin: filters.origin,
        providerId: filters.providerId,
      },
      this.httpOptions
    );
  }

  getReportData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-game-report`,
      {
        user_name: filters.user_name,
        start_time: filters.start_time,
        end_time: filters.end_time,
        category: filters.category,
        origin: filters.origin,
        status: filters.status,
        provider_id: filters.provider_id,
      },
      this.httpOptions
    );
  }

  getGameReport(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-provider-game-report`,
      filters,
      this.httpOptions
    );
  }

  getGameReportByProvider(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-sport-game-report`,
      filters,
      this.httpOptions
    );
  }

  getSapMetricsData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-operator-matrics-report-excell`,
      {
        userName: filters.userName,
        userId: filters.userId,
        operatorId: filters.operatorId,
        status: filters.status,
        sportId: filters.sportId,
        startTime: filters.startTime,
        endTime: filters.endTime,
        providerId: filters.providerId,
        origin: filters.origin,
        sportName: filters.sportName,
        operators: filters.operators,
      },
      this.httpOptions
    );
  }

  getGMReportBySportLevel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-competition-game-report`,
      filters,
      this.httpOptions
    );
  }

  getGMReportByCompetitionLevel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-event-game-report`,
      filters,
      this.httpOptions
    );
  }

  getGMReportByMarketLevel(filters: any) {
    console.log(filters);
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-market-game-report`,
      filters,
      this.httpOptions
    );
  }

  getGMReportByUserLevel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-user-game-report`,
      filters,
      this.httpOptions
    );
  }

  getPLData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-provider-pnl-report`,
      filters,
      this.httpOptions
    );
  }
  getSportPLData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-sport-pnl-report`,
      filters,
      this.httpOptions
    );
  }
  getCompetitionPLData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-competition-pnl-report`,
      filters,
      this.httpOptions
    );
  }

  getMtsSports(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/sports`,
      filters,
      this.httpOptions
    );
  }

  getMtsAccounts(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/accounts`,
      filters,
      this.httpOptions
    );
  }

  getMtsAccountList(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/account-list`,
      filters,
      this.httpOptions
    );
  }

  getMtsAccountDetail(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/account-detail`,
      filters,
      this.httpOptions
    );
  }

  getMtsAccountBets(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/account-bets`,
      filters,
      this.httpOptions
    );
  }

  getMtsAccountRejections(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/account-rejections`,
      filters,
      this.httpOptions
    );
  }

  // The ticket-level list: accepted or refused bets across accounts, with the
  // report's own filters.
  getMtsBets(filters: any) {
    return this.http.post<any>(`${environment.apiUrl1}/mts/bets`, filters, this.httpOptions);
  }

  getMtsProfitability(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/profitability`,
      filters,
      this.httpOptions
    );
  }

  getMtsReportingSummary(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/mts/reporting-summary`,
      filters,
      this.httpOptions
    );
  }

  getLeakLedgerSummary(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/leak-ledger-summary`,
      filters,
      this.httpOptions
    );
  }

  getLeakLedgerCategoryBreakdown(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/leak-ledger-category-breakdown`,
      filters,
      this.httpOptions
    );
  }

  getLeakLedgerEventMarkets(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/leak-ledger-event-markets`,
      filters,
      this.httpOptions
    );
  }

  triggerLeakLedgerBackfill(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/leak-ledger-trigger-backfill`,
      payload,
      this.httpOptions
    );
  }

  getHoldReport(payload: HoldReportReq) {
    return this.http.post<HoldReportResp>(
      `${environment.apiUrl1}/reports/sr-fallback-holds`,
      payload,
      this.httpOptions
    );
  }

  triggerHoldReportBackfill(fromDate: string, toDate: string) {
    return this.http.post<{ status: string; errorDescription: string }>(
      `${environment.apiUrl1}/reports/sr-fallback-holds-backfill`,
      { fromDate, toDate },
      this.httpOptions
    );
  }
  getEventPLData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-event-pnl-report`,
      filters,
      this.httpOptions
    );
  }
  getMarketPLData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-sport-report`,
      filters,
      this.httpOptions
    );
  }

  geUserPLData(filters) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-users-report`,
      filters,
      this.httpOptions
    );
  }

  getUserAuditData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-user-audit-report
      `,
      {
        user_name: filters.user_name,
        start_time: filters.start_time,
        end_time: filters.end_time,
        operation: filters.operation,
        ip: filters.ip,
      },
      this.httpOptions
    );
  }
  getSAPMetricsData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-operator-matrics-report
      `,
      {
        providerId: filters.providerId,
        startTime: filters.start_time,
        endTime: filters.end_time,
        sportId: filters.sportId,
        origin: filters.origin,
        sportName: filters.sportName,
        operators: filters.operators,
      },
      this.httpOptions
    );
  }
  getAdminStatmentData(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-my-account-statement`,
      {
        user_name: filters.user_name,
        start_time: filters.start_time,
        end_time: filters.end_time,
        status: filters.status,
      },
      this.httpOptions
    );
  }

  getUsersList(query?: string, OperatorId?: any) {
    if (this.ForSAP || this.ForGA) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-users`,
        {
          page: 0,
          pageSize: 5,
          partialUserName: query,
          operators: OperatorId,
        },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/list-users`,
        { page: 0, pageSize: 5, partialUserName: query },
        this.httpOptions
      );
    }
  }

  // provider list for OperatorAdmin role
  getOurProviders() {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/get-saproviders`,
        {},
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/get-providers`,
        {},
        this.httpOptions
      );
    }
  }
  getOurProviders1(oid: string) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/get-saproviders`,
        {},
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/get-oaproviders`,
        { operatorId: oid },
        this.httpOptions
      );
    }
  }

  getOperatorProvidersStatus(oid: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/get-operator-provider-statuses`,
      {
        params: {
          operatorId: oid,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
          SecretKey: "t046CIsQCBwaIMLca3mxP2ClnB2H8G4z",
        },
      }
    );
  }

  enableProvider(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/enable-operator-provider`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
          SecretKey: "t046CIsQCBwaIMLca3mxP2ClnB2H8G4z",
        },
      }
    );
  }

  disableProvider(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/disable-operator-provider`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
          SecretKey: "t046CIsQCBwaIMLca3mxP2ClnB2H8G4z",
        },
      }
    );
  }

  //after click row on provider list
  getOurProvidersStatus(data: { provider_id: string }) {
    return this.http.post<any>(
      `${environment.apiUrl}/get-provider-status`,
      data,
      this.httpOptions
    );
  }
  //after click row on provider list
  getOperatorsData(data: {
    ProviderId: string;
    SportId: string;
    CompetitionId: string;
    EventId: string;
  }) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/operator-details`,
      data,
      this.httpOptions
    );
  }

  // change status for operator.
  changeOperatorStatus(
    pid: string,
    oid: any,
    partnerId: string,
    sid: string,
    cid: string,
    eid: string,
    status: string,
    level: string,
    group:string,
  ) {
    switch (level) {
      case "provider": {
        return this.http.post<any>(
          `${environment.apiUrl}/sapadmin/provider-operator-status`,
          {
            OperatorId: oid,
            ProviderId: pid,
            Status: status,
            PartnerId: partnerId,
          },
          this.httpOptions
        );
      }

      case "sport": {
        return this.http.post<any>(
          `${environment.apiUrl}/sapadmin/sport-operator-status`,
          {
            OperatorId: oid,
            ProviderId: pid,
            SportId: sid,
            Status: status,
          },
          this.httpOptions
        );
      }

      case "competition": {
        const operators = Array.isArray(oid) ? oid : [oid];
        return this.http.post<any>(
          `${environment.apiUrl}/sapadmin/competition-operator-status`,
          {
            operators: operators,
            providerId: pid,
            sportId: sid,
            competitionId: cid,
            status: status,
            group:group,
          },
          this.httpOptions
        );
      }

      case "event": {
        const operators = Array.isArray(oid) ? oid : [oid];
        return this.http.post<any>(
          `${environment.apiUrl}/sapadmin/event-operator-status`,
          {
            operators: operators,
            providerId: pid,
            sportId: sid,
            eventId: eid,
            status: status,
            group:group,
          },
          this.httpOptions
        );
      }
    }
  }

  getOurOperators() {
    return this.http.post<any>(
      `${environment.apiUrl}/get-operators`,
      {},
      this.httpOptions
    );
  }
  unBlockOperators(oid: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/unblock-operator`,
      {
        OperatorId: oid,
      },
      this.httpOptions
    );
  }
  blockOperators(oid: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/block-operator`,
      { OperatorId: oid },
      this.httpOptions
    );
  }

  getOurPartners() {
    return this.http.post<any>(
      `${environment.apiUrl}/get-partners`,
      {},
      this.httpOptions
    );
  }
  // add Partner
  addPartner(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/add-partner`,
      data,
      this.httpOptions
    );
  }
  // update Partner
  updatePartner(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/replace-partner`,
      data,
      this.httpOptions
    );
  }

  // update Operators
  replaceOperators(data) {
    if (!this.NmUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/replace-operators`,
      data,
      this.httpOptions
    );
  }

  unBlockPartners(oid: string, partnerId: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/unblock-partner`,
      {
        OperatorId: oid,
        PartnerId: partnerId,
      },
      this.httpOptions
    );
  }
  blockPartners(oid: string, partnerId: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/block-partner`,
      {
        OperatorId: oid,
        PartnerId: partnerId,
      },
      this.httpOptions
    );
  }

  // get sport data by provider id

  // start *****************************************
  getSportData(pid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/sports`,
        { ProviderId: pid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/sports`,
        { ProviderId: pid },
        this.httpOptions
      );
    }
  }

  getSportForBetList(pid: string) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/sports`,
        { ProviderId: pid },
        this.httpOptions
      );
  }

  getSportCatalogData(oid: string, pid: string) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/sports`,
        { ProviderId: pid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/sports`,
        { OperatorId: oid, ProviderId: pid },
        this.httpOptions
      );
    }
  }

  // *****************************************End

  // change sport status
  // start *****************************************
  unBlockSports(oid: string, sid: string, pid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unblock-sport`,
        { ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/unblock-sport`,
        { OperatorId: oid, ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    }
  }

  blockSports(oid: string, sid: string, pid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/block-sport`,
        { ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    }
    {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/block-sport`,
        { OperatorId: oid, ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    }
  }

  // *****************************************End

  // get Competition Data by provider id & sport id
  getCompetitionData = (oid: string, pid: string, sid: string, startTime,endTime) => {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/compititions`,
        { ProviderId: pid, SportId: sid,startTime: startTime, endTime:endTime  },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/compititions`,
        { OperatorId: oid, ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    }
  };

  getCompetitionDataList = (pid: string, sid: string) => {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/competitions-excell`,
      { ProviderId: pid, SportId: sid },
      this.httpOptions
    );
  };

  getEventsDataList = (pid: string, sid: string, cid: string) => {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/events-excell`,
      { ProviderId: pid, SportId: sid, CompetitionId: cid },
      this.httpOptions
    );
  };

  //fetching competitionsList for catalog management

  getCatalogCompetitions(
    pid: string,
    sid: string,
    fromDate,
    toDate,
    page,
    pageSize
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/get-competitions`,
      {
        providerId: pid,
        sportId: sid,
        startDate: fromDate.toDate().setHours(0, 0, 0) / 1000,
        endDate: Number(
          String(toDate.toDate().setHours(23, 59, 59) / 1000).slice(0, 11)
        ),
      },
      this.httpOptions
    );
  }

  changeCompetitionStatus(
    pid: string,
    sid: string,
    competitionId: string,
    Status: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/set-competition-status`,
      {
        ProviderId: pid,
        SportId: sid,
        competitionId: competitionId,
        status: Status,
      },
      this.httpOptions
    );
  }

  changeCatalogEventStatus = (
    pid: string,
    sid: string,
    eventId: string,
    Status: string
  ) => {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/set-event-status`,
      {
        ProviderId: pid,
        SportId: sid,
        eventId: eventId,
        status: Status,
      },
      this.httpOptions
    );
  };

  getRecentCompetitionData = (oid: string, pid: string, sid: string) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/recent-compititions`,
        { ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/recent-compititions`,
        { OperatorId: oid, ProviderId: pid, SportId: sid },
        this.httpOptions
      );
    }
  };
  // change compititions status
  // start *****************************************
  unBlockCompititions(oid: string, pid: string, sid: string, cid: string) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unblock-competition`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/unblock-competition`,
        { OperatorId: oid, ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    }
  }

  blockCompititions(oid: string, pid: string, sid: string, cid: string) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/block-competition`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    }
    {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/block-competition`,
        { OperatorId: oid, ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    }
  }

  // *****************************************End

  // get Event Data by provider id & sport id & competition id
  getEventsData = (pid: string, sid: string, cid: string) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/events`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/events`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    }
  };

  getEventsCatalogData = (
    oid: string,
    pid: string,
    sid: string,
    cid: string,
    startTime,
    endTime
  ) => {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/events`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid, startTime:startTime, endTime: endTime },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/events`,
        { OperatorId: oid, ProviderId: pid, SportId: sid, CompetitionId: cid },
        this.httpOptions
      );
    }
  };

  getMarketData = (pid: string, sid: string, eid: string) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-markets`,
        { providerId: pid, sportId: sid, eventId: eid },

        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-markets`,
        { providerId: pid, sportId: sid, eventId: eid },
        this.httpOptions
      );
    }
  };

  getMarketCatalogData = (
    oid: string,
    pid: string,
    sid: string,
    eid: string
  ) => {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-markets`,
        { providerId: pid, sportId: sid, eventId: eid },

        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-markets`,
        { operatorId: oid, providerId: pid, sportId: sid, eventId: eid },
        this.httpOptions
      );
    }
  };

  getMarketRisk = (
    pid: string,
    eventID: string,
    marketId?: string,
    user?: string
  ) => {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-operator-risk-report`,
      {
        providerId: pid,
        userId: user,
        eventId: eventID,
        // sportId: "4",
        marketId: marketId,
      },
      this.httpOptions
    );
  };

  getOperatorRisk = (pid: string, sid: string, eid?: string) => {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-risk-analysis-report`,
      {
        providerId: "Exchange",
        sportId: sid,
        operatorId: "",
        eventId: eid,
        competitionId: "",
      },
      this.httpOptions
    );
  };

  // change Event status
  // start *****************************************
  unBlockEvent(
    oid: string,
    pid: string,
    sid: string,
    cid: string,
    eid: string
  ) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unblock-event`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid, EventId: eid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/unblock-event`,
        {
          OperatorId: oid,
          ProviderId: pid,
          SportId: sid,
          CompetitionId: cid,
          EventId: eid,
        },
        this.httpOptions
      );
    }
  }

  blockEvent(oid: string, pid: string, sid: string, cid: string, eid: string) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/block-event`,
        { ProviderId: pid, SportId: sid, CompetitionId: cid, EventId: eid },
        this.httpOptions
      );
    }
    {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/block-event`,
        {
          OperatorId: oid,
          ProviderId: pid,
          SportId: sid,
          CompetitionId: cid,
          EventId: eid,
        },
        this.httpOptions
      );
    }
  }

  // *****************************************End

  setetFavoriteEvent(
    oid: string,
    pid: string,
    sid: string,
    eid: string,
    isFavourate: boolean
  ) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/favourite-events`,
        { ProviderId: pid, SportId: sid, favourite: isFavourate, EventId: eid },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/favourite-events`,
        {
          OperatorId: oid,
          ProviderId: pid,
          SportId: sid,
          favourite: isFavourate,
          EventId: eid,
        },
        this.httpOptions
      );
    }
  }

  getSportsList(pid: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/list-sports"`,
      { providerId: pid },
      this.httpOptions
    );
  }

  getEventsBySportsList(pid: string, sportId: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/list-events`,
      { providerId: pid, sportId: sportId },
      this.httpOptions
    );
  }

  getCatalogEvents(
    pid: string,
    sportId: string,
    startDate,
    endDate,
    page,
    pageSize
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/get-events`,
      {
        providerId: pid,
        sportId: sportId,
        startDate: startDate.toDate().setHours(0, 0, 0) / 1000,
        endDate: Number(
          String(endDate.toDate().setHours(23, 59, 59) / 1000).slice(0, 11)
        ),
      },
      this.httpOptions
    );
  }

  getEventsForSettlemets(pid: string, sportId: string, startDate, endDate) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-events`,
      {
        providerId: pid,
        sportId: sportId,
        startDate: startDate,
        endDate: endDate,
      },
      this.httpOptions
    );
  }

  getEventsDetailsForSettlemets(
    eventId: string,
    sportId: string,
    providerId: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-markets`,
      {
        eventId: eventId ? eventId : "",
        sportId: sportId ? sportId : "",
        providerId: providerId ? providerId : "",
      },
      this.httpOptions
    );
  }

  mapMarkets(
    eventId: string,
    sportId: string,
    providerId: string,
    marketId: string,
    runnerId: string,
    runner_name: string,
    sessionOutcome: any
  ) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/settlements-map-market`,
      {
        providerId: providerId ? providerId : "",
        sportId: sportId ? sportId : "",
        eventId: eventId ? eventId : "",
        marketId: marketId,
        runnerId: runnerId,
        runnerName: runner_name,
        sessionOutcome: isNaN(sessionOutcome) ? 0 : Number(sessionOutcome),
      },
      this.httpOptions
    );
  }

  setMarketToOpen(
    eventId: string,
    sportId: string,
    providerId: string,
    marketId: string
  ) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/settlements-open-market`,
      {
        providerId: providerId ? providerId : "",
        sportId: sportId ? sportId : "",
        eventId: eventId ? eventId : "",
        marketId: marketId,
      },
      this.httpOptions
    );
  }

  setMarketToSettle(
    eventId: string,
    sportId: string,
    providerId: string,
    marketId: string,
    runnerId: string,
    runnerName: string,
    sessionOutcome: string
  ) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/settlements-settle-market`,
      {
        providerId: providerId ? providerId : "",
        sportId: sportId ? sportId : "",
        eventId: eventId ? eventId : "",
        marketId: marketId,
        runnerId: runnerId,
        runnerName: runnerName,
        sessionOutcome: sessionOutcome ? sessionOutcome : 0,
      },
      this.httpOptions
    );
  }

  SetMarketToVoid(
    eventId: string,
    sportId: string,
    providerId: string,
    marketId: string,
    marketName: string,
    marketType: string,
    rollbackType: string,
    rollbackReason: string
  ) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/settlements-void-market`,
      {
        providerId: providerId ? providerId : "",
        sportId: sportId ? sportId : "",
        eventId: eventId ? eventId : "",
        marketId: marketId,
        marketName: marketName,
        marketType: marketType,
        rollbackType: rollbackType ? rollbackType : "",
        reason: rollbackReason,
      },
      this.httpOptions
    );
  }

  RollBackMarket(
    eventId: string,
    sportId: string,
    providerId: string,
    marketId: string,
    marketType: string,
    rollbackType: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/settlement/market-void`,
      {
        providerId: providerId ? providerId : "",
        sportId: sportId ? sportId : "",
        eventId: eventId ? eventId : "",
        marketId: marketId,
        rollbackType: rollbackType,
        rollbackReason: "Testing",
      },
      this.httpOptions
    );
  }

  getUserAccountStmt(filters: any) {
    const postBody = {
      operatorId: filters.operatorId,
      userId: filters.userId,
      page: filters.page,
      pageSize: filters.pageSize ? filters.pageSize : 30,
      endTime: 0,
      startTime: 0,
      // token: "string",
    };

    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-transfer-user-statement`,
      postBody,
      this.httpOptions
    );
  }

  getBetDetails(betID: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/get-bet`,
      {
        operatorId: this.userInfo.operatorId,
        transactionId: betID,
      },
      this.httpOptions
    );
  }

  getBetInfo(betID: string) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-bet-detail-report`,
      {
        transactionId: betID,
      },
      this.httpOptions
    );
  }

  getOperatorData() {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/get-operator-details`,
      null,
      this.httpOptions
    );
  }

  // add new user
  addUsers(data) {
    if (!this.NmUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/createuser`,
      data,
      this.httpOptions
    );
  }

  // changePassword(data, page) {
  //   if (this.ForSAP) {
  //     if (page === "user-management") {
  //       return this.http.post<any>(
  //         `${environment.apiUrl}/sapadmin/reset-op-password`,
  //         data,
  //         this.httpOptions
  //       );
  //     } else {
  //       return this.http.post<any>(
  //         `${environment.apiUrl}/sapadmin/reset-password`,
  //         data,
  //         this.httpOptions
  //       );
  //     }
  //   } else {
  //     return this.http.post<any>(
  //       `${environment.apiUrl}/opadmin/reset-password`,
  //       data,
  //       this.httpOptions
  //     );
  //   }
  // }

  changePassword(data) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/reset-password`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/reset-password`,
        data,
        this.httpOptions
      );
    }
  }

  resetUserPassword(body: any) {
    if (!this.MainUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/reset-op-password`,
      body,
      this.httpOptions
    );
  }

  getOperatorConfigData(data: BetConfigReqParams) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-config`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-config`,
        data,
        this.httpOptions
      );
    }
  }
  // getOperatorConfigDataForOprator() {
  //   if (this.ForSAP) {
  //       return this.http.post<any>(
  //         `${environment.apiUrl}/sapadmin/get-config`,
  //         {},
  //         this.httpOptions
  //       )
  //     }
  // }
  setOperatorConfigData(data) {
    let opData = data;
    // if (data.ConfigCall !== "partner") {
    //   delete opData["PartnerId"];
    // }
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/set-config`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/set-config`,
        opData,
        this.httpOptions
      );
    }
  }
  getOperatorLimits(data) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/list-operator-limits`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/list-operator-limits`,
        data,
        this.httpOptions
      );
    }
  }

  createOperatorLimit(data) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/create-operator-limit`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/create-operator-limit`,
        data,
        this.httpOptions
      );
    }
  }

  updateOperatorLimit(data) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/update-operator-limit`,
        data,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/update-operator-limit`,
        data,
        this.httpOptions
      );
    }
  }

  getOperatorId() {
    if (this.ForSAP || this.ForGA) {
      return this.http.post<any>(
        `${environment.apiUrl}/get-operators`,
        null,
        this.httpOptions
      );
    }
  }

  getOperatorWallet() {
    return this.http.post<any>(
      `${environment.apiUrl}/get-operators`,
      null,
      this.httpOptions
    );
  }

  // add new operator
  addOperators(data) {
    if (!this.NmUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/createoperator`,
      data,
      this.httpOptions
    );
  }

  getOpAdminCurrencies(oid: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-partner-ids`,
        null,
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-partner-ids`,
        { operatorId: oid },
        this.httpOptions
      );
    }
  }
  depositFunds(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/deposit-funds`,
      data,
      this.httpOptions
    );
  }
  withdrawFunds(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/withdraw-funds`,
      data,
      this.httpOptions
    );
  }

  getPartnerId(OId) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-partner-ids`,
      { OperatorId: OId },
      this.httpOptions
    );
  }

  mapEvents(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/management/add-b2s-mapping`,
      data,
      this.httpOptions
    );
  }

  getMappedEvents(startDate, endDate, sportId) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-b2smap`,
      { startDate, endDate, sportId },
      this.httpOptions
    );
  }

  getOperatorColorConfigurations(operatorId: string,lobby: string,configId) {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/get-color-configuration2`,
      {
        operatorId:
          this.userInfo.role === SapRoles.SAPAdmin || roleTypeGroup.includes(this.userInfo.role)
            ? operatorId
            : this.userInfo.operatorId,
        lobby_name: lobby,
        config_id: configId
      },
      this.httpOptions
    );
  }

  getEnabledSportsForOperator(operatorId: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/opadmin/operator-enabled-sports`,
      {
        params: {
          operatorId: operatorId,
        },
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
          Secretkey: "d0ea7009-17f1-4f30-812a-6c613521313f",
        }),
      }
    );
  }

  setOperatorColorConfiguration(
    // primaryColor,
    // backgroundColor,
    // subHeaderColor,
    // tableBg,
    // tableHead,
    // textColor,
    fd
  ) {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/set-color-configuration2`,
      {
        // operatorId: "hypexexch01",
        // primaryColor: primaryColor,
        // background: backgroundColor,
        // subHeaderColor: subHeaderColor,
        // tableBackground: tableBg,
        // tableHead: tableHead,
        // textColor: textColor,
        fd,
      },
      this.httpOptions
    );
  }

  getUnMappedEvents(SportId, ProviderId, startDate, endDate) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-unmapped-events`,
      {
        SportId,
        ProviderId,
        startDate,
        endDate,
      },
      this.httpOptions
    );
  }
 
  flagEvent(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapAdmin/flag-event`,
      payload,
      this.httpOptions
    );
  }

  samepleApi(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/set-color-configuration2`,
      payload,
      this.httpOptions2
    );
  }

  deleteBanner(bannerIndex, banner, operatorId) {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/delete-operator-banner`,
      {
        operatorId: operatorId,
        bannerIndex: bannerIndex,
        bannerUrl: banner,
      },
      this.httpOptions2
    );
  }

  addCommissionMarket(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/opadmin/update-commission-market`,
      payload,
      this.httpOptions
    );
  }

  uploadThumbnail(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/update-competition-thumbnail`,
      payload,
      this.httpOptions
    );
  }

  getCompetitionThumbnails(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-competition-thumbnails`,
      payload,
      this.httpOptions
    );
  }

  addMarketMapping(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/management/add-b2s-market-mapping`,
      payload,
      this.httpOptions
    );
  }

  setProvider(data) {
    this.selectedProvider = data;
  }

  getProvider() {
    return this.selectedProvider;
  }

  setSport(data) {
    this.selectedSport = data;
  }

  getSport() {
    return this.selectedSport;
  }

  setCompetition(data) {
    this.selectedCompetiton = data;
  }

  getCompetition() {
    return this.selectedCompetiton;
  }

  setMarket(data) {
    this.selectedMarket = data;
  }

  getMarket() {
    return this.selectedMarket;
  }

  addMarket(payload: any) {
    return this.http.post<any>(
      `${environment.sapapi}/core/add-manual-market`,
      payload,
      this.httpOptions
    );
  }

  updateMarket(payload: any) {
    return this.http.post<any>(
      `${environment.sapapi}/core/update-manual-market`,
      payload,
      this.httpOptions
    );
  }

  deleteMarket(payload: any) {
    return this.http.post<any>(
      `${environment.sapapi}/core/delete-manual-market`,
      payload,
      this.httpOptions
    );
  }

  deleteUser(userId: string) {
    if (!this.MainUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/deleteuser`,
      {
        userId: userId,
      },
      this.httpOptions
    );
  }

  updateUser(data: any) {
    if (!this.NmUsers.includes(this.userInfo.userId)) {
      return
    }
    return this.http.post<any>(
      `${environment.apiUrl}/update-user`,
      data,
      this.httpOptions
    );
  }

  getSettlementMarkets(providerId, sportId, startDate, endDate) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-settlement-markets`,
      {
        providerId: providerId,
        sportId: sportId,
        startDate: startDate.valueOf(),
        endDate: endDate.valueOf(),
      },
      this.httpOptions
    );
  }

  getMarketsBets(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-market-bets`,
      data,
      this.httpOptions
    );
  }

  getBetMonitorList(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/bets-monitor`,
      {
        userName: filters.userName,
        operatorId: filters.operatorId,
        status: filters.status,
        sportId: filters.sportName,
        startTime: filters.startTime,
        endTime: filters.endTime,
        event_id: filters.eventId,
        market_id: filters.marketId,
        providerId: filters.providerId,
        PageSize: filters.PageSize,
        Page: filters.Page,
        stakeAmount: filters.stake,
        ip: filters.ip,
        origin: filters.origin,
        category: filters.category,
      },
      this.httpOptions
    );
  }

  getBetMonitorEvents(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/fetch-events`,
      {
        status: filters.status,
        sportNames: filters.sportName,
        startTime: filters.startTime,
        endTime: filters.endTime,
        providerId: filters.providerId,
      },
      this.httpOptions
    );
  }

  getBetMonitorMarkets(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/fetch-markets`,
      {
        status: filters.status,
        sportNames: filters.sportName,
        startTime: filters.startTime,
        endTime: filters.endTime,
        event_id: filters.eventId,
        providerId: filters.providerId,
      },
      this.httpOptions
    );
  }

  alertBet(betID: string, remarks: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/alertbet`,
      {
        transactionId: betID,
        remarks: remarks,
      },
      this.httpOptions
    );
  }

  getAlertBets(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/get-alerted-bets`,
      {
        alertStatus: filters.alertStatus,
        startTime: filters.startTime,
        endTime: filters.endTime,
        PageSize: filters.PageSize,
        Page: filters.Page,
      },
      this.httpOptions
    );
  }

  settleAlertedBet(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/settle-alerted-bet`,
      {
        alertStatus: filters.alertStatus,
        transactionId: filters.transactionId,
        rollbackReason: filters.rollbackReason,
        password: filters.password,
      },
      this.httpOptions
    );
  }

  voidBets(data: any) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/bets-void`,
      data,
      this.httpOptions
    );
  }

  timelyVoidBets(data: any) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/void-timely-bets`,
      data,
      this.httpOptions
    );
  }

  getCatalogExportExcel(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/catalog-management-excel`,
      {
        providerId: filters.providerId,
        startDate: filters.startTime,
        endDate: filters.endTime,
      },
      this.httpOptions
    );
  }

  getGameAnalysisEvents(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/list-events`,
      {
        sportId: filters.sportId,
        fromDate: filters.startTime,
        todate: filters.endTime,
      },
      this.httpOptions
    );
  }

  getGameAnalysis(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/game-analysis`,
      {
        sportId: filters.sportId,
        reportType: filters.report,
        eventId: filters.eventId,
        startDate: filters.startTime,
        endDate: filters.endTime,
      },
      this.httpOptions
    );
  }

  getGameAnalysisSummary(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/game-analysis-summary`,
      {
        sportId: filters.sportId,
        reportType: filters.report,
        eventId: filters.eventId,
        startDate: filters.startTime,
        endDate: filters.endTime,
      },
      this.httpOptions
    );
  }

  opCategory(oid: string) {
    return this.http.post<any>(
      `${environment.mappingUrl}/core/enabled-categories`,
      {
        operatorId: oid,
      },
      this.httpOptions
    );
  }
  
  getTommyManualData() {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/tommy-manual`,
        {},
        this.httpOptions
      );
    }
  }

  getOpDailySummary(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/op-daily-summary`,
      data,
      this.httpOptions
    );
  }

  getOpTopPlayers(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/op-top-players`,
      data,
      this.httpOptions
    );
  }
  
  createTommyManualData(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/create-tommy-manual`,
        payload,
        this.httpOptions
      );
    }
  }
  
  updateTommyManualData(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/update-tommy-manual`,
        payload,
        this.httpOptions
      );
    }
  }

getEventBets(data) {
  return this.http.post<any>(
    `${environment.apiUrl1}/operations/list-bets`,
    data,
    this.httpOptions
  );
}

betSettle(data) {
  return this.http.post<any>(
    `${environment.settlementUrl}/operations/bet-open-settle`,
    data,
    this.httpOptions
  );
}

  betVoid(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/bet-open-void`,
      data,
      this.httpOptions
    );
  }

  listEventMarkets(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/list-markets`,
      data,
      this.httpOptions
    );
  }

  betRollback(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/bet-settle-open`,
      data,
      this.httpOptions
    );
  }

  getSettledOpenBets(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-settled-open-bets`,
      data,
      this.httpOptions
    );
  }

  getDbReports(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-db-collection`,
      payload,
      this.httpOptions
    );
  }

  mapPremium(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/management/premium-mapping`,
      data,
      this.httpOptions
    );
  }

  getEventsForOP(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/op-get-events`,
      data,
      this.httpOptions
    );
  }
  
  getMarketsForOP(
    eventId: string,
    sportId: string,
    providerId: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/op-get-markets`,
      {
        eventId: eventId ? eventId : "",
        sportId: sportId ? sportId : "",
        providerId: providerId ? providerId : "",
      },
      this.httpOptions
    );
  }

  getUnmappedEventsCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/unmapped-count`,
      data,
      this.httpOptions
    );
  }

  getOPBets(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/list-op-bets`,
      data,
      this.httpOptions
    );
  }

  flagUser(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/flag-bet`,
      data,
      this.httpOptions
    );
  }

  getAlertBetsCount(){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/alert-bets-count`,
      {},
      this.httpOptions
    );
  }

  getUsersCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/users-count`,
      data,
      this.httpOptions
    );
  }
  
  getOPUsersCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/op-users-count`,
      data,
      this.httpOptions
    );
  }

  getBetsCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/bets-count`,
      data,
      this.httpOptions
    );
  }
  
  getOPBetsCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/op-bets-count`,
      data,
      this.httpOptions
    );
  }

  getPRBetsCount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/pr-bets-count`,
      data,
      this.httpOptions
    );
  }

  getBetsAmount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/bets-amount`,
      data,
      this.httpOptions
    );
  }

  getOPBetAmount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/op-bets-amount`,
      data,
      this.httpOptions
    );
  }
  
  getPRBetAmount(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/pr-bets-amount`,
      data,
      this.httpOptions
    );
  }
  
  multiBetSettle(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/multibets-open-settled`,
      data,
      this.httpOptions
    );
  }
  
  multiBetVoid(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/multibets-open-void`,
      data,
      this.httpOptions
    );
  }
  
  multiBetRollback(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/multibets-settled-open`,
      data,
      this.httpOptions
    );
  }

  getB2sMarketMap(data) {
    return this.http.post<any>(
      `${environment.catalogUrl}/mapping/get-allb2smarketmaps`,
      data,
      {
        headers: new HttpHeaders({
          Secretkey: "d0ea7009-17f1-4f30-812a-6c613521313f",
        }),
      }
    );
  }

  unMapMarket(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/unmap-b2smarketmap`,
      payload,
      this.httpOptions
    );
  }

  getVoidedMarkets(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-void-markets`,
      data,
      this.httpOptions
    );
  }
  
  getVoidedMarketsExcel(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/get-void-markets-excel`,
      data,
      this.httpOptions
    );
  }

  getOPCommissionDocs(operatorId) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/get-commission-records`,
        {operatorId:operatorId},
        this.httpOptions
      );
    }
  }

  createOpCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/add-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  updateOpCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/edit-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  createIframeCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/add-iframe-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  updateIframeCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/edit-iframe-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  cloneCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/clone-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  invoiceReport(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/get-report`,
        payload,
        this.httpOptions
      );
    }
  }

  updateWaiveAmount(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/update-waive-amount`,
        payload,
        this.httpOptions
      );
    }
  }

  updateReportCommission(payload) {
    if (this.userInfo.invoice) {
      return this.http.post<any>(
        `${environment.apiUrl1}/invoice/update-report-commission`,
        payload,
        this.httpOptions
      );
    }
  }

  blockMappedMarket(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/update-b2smarketmap-status`,
      data,
      this.httpOptions
    );
  }

  getmarketReport(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/dashboard/market-report`,
      data,
      this.httpOptions
    );
  }

  updateRXEventStatus(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/update-event-status`,
        payload,
        this.httpOptions
      );
    }
  }

  getRXEventStatus(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-event-status`,
        payload,
        this.httpOptions
      );
    }
  }

  holdMarket(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/operations/hold-market`,
      data,
      this.httpOptions
    );
  }

  getPremiumEvents(data){
    return this.http.post<any>(
      `${environment.catalogUrl}/premium/events`,
      data,
      this.httpOptions
    );
  }

  getPremiumMarkets(data){
    return this.http.post<any>(
      `${environment.catalogUrl}/premium/markets`,
      data,
      this.httpOptions
    );
  }

  updatePremiumMarketStatus(data){
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/update-market-status`,
      data,
      this.httpOptions
    );
  }

  addCatalogueRule(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl1}/catalog/add-rule`,
        payload,
        this.httpOptions
      );
    }
  }

  editCatalogueRule(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl1}/catalog/edit-rule`,
        payload,
        this.httpOptions
      );
    }
  }

  getCatalogueRule(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl1}/catalog/get-rules`,
        payload,
        this.httpOptions
      );
    }
  }

  deleteCatalogueRule(payload) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl1}/catalog/delete-rule`,
        payload,
        this.httpOptions
      );
    }
  }
  
  fetchOurOperators() {
    return this.http.post<any>(
      `${environment.apiUrl}/fetch-operators`,
      {},
      this.httpOptions
    );
  }

  opBetRollback(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/op-bet-rollback`,
      data,
      this.httpOptions
    );
}

  opBetVoid(data) {
    return this.http.post<any>(
      `${environment.settlementUrl}/operations/op-bet-void`,
      data,
      this.httpOptions
    );
  }

  editB2sMap(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/edit-b2smap`,
      data,
      this.httpOptions
    );
  }

  getThumbnails(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-thumbnails`,
      data,
      this.httpOptions
    );
  }

  updateThumbnail(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/update-thumbnail`,
      data,
      this.httpOptions
    );
  }

  uploadEventThumbnail(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/upload-thumbnail`,
      data,
      this.httpOptions2
    );
  }

  getPremiumUnmappedMarkets(data){
    return this.http.post<any>(
      `${environment.catalogUrl}/premium/unmapped-markets`,
      data,
      this.httpOptions
    );
  }

  getPremiumMappedMarkets(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/mapped-markets`,
      payload,
      this.httpOptions
    );
  }

  mapPremiumMarkets(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/map-t2smarket`,
      payload,
      this.httpOptions
    );
  }

  changeMapMarketStatus(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/update-mapped-market-status`,
      payload,
      this.httpOptions
    );
  }

  blockAllMappedMarkets(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/block-all-mapped-markets`,
      payload,
      this.httpOptions
    );
  }

  getGeniePremiumUnMappedEvents(payload:any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/get-unmapped-events`,
      payload,
      this.httpOptions
    );
  }

  getGeniePremiumMappedEvents(payload:any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/get-mapped-events`,
      payload,
      this.httpOptions
    );
  }

  addGeniePremiumEvent(payload:any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/add-mapping`,
      payload,
      this.httpOptions
    );
  }

  editGeniePremiumMap(data) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/edit-mapping`,
      data,
      this.httpOptions
    );
  }

  unmapPremiumMarket(payload) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/unmap-premium-market`,
      payload,
      this.httpOptions
    );
  }

  getArbitrageConfig() {
    return this.http.post<any>(
      `${environment.apiUrl}/get-arbitrage-config`,
      {},
      this.httpOptions
    );
  }

  setArbitrageConfig(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/set-arbitrage-config`,
      data,
      this.httpOptions
    );
  }

  getSportLevelArbitrageDecisions(filters:any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-sport-decisions`,
      filters,
      this.httpOptions
    );
  }

  getEventLevelArbitrageDecisions(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-event-decisions`,
      filters,
      this.httpOptions
    );
  }

  getArbitrageDecisions(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-decisions`,
      filters,
      this.httpOptions
    );
  }

  getArbitrageBetsSummary(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-bets-summary`,
      filters,
      this.httpOptions
    );
  }

  getEventBetsSummary(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-event-bets-summary`,
      filters,
      this.httpOptions
    );
  }

  getPlacedBets(filters: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/arbitrage/get-bets`,
      filters,
      this.httpOptions
    );
  }

  viewMarketDetails(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-b2smarketmap`,
      data,
      this.httpOptions
    );
  }

  editB2sMappedMarket(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/edit-b2smarketmap`,
      payload,
      this.httpOptions
    );
  }

  updateEventFields(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/catalog/update-event-fields`,
      data,
      this.httpOptions
    );
  }

  unMapEvent(payload) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/unmap-b2smap`,
      payload,
      this.httpOptions
    );
  }

  getB2sMapAutoCandidates(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-b2smap-auto-candidates`,
      payload,
      this.httpOptions
    );
  }

  promoteB2sMapAutoCandidate(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/promote-b2smap-auto-candidate`,
      payload,
      this.httpOptions
    );
  }

  unmapGeniePremiumEvent(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/unmap-mapping`,
      payload,
      this.httpOptions
    );
  }

  getPremiumMarketAutoMapConfigs(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/get-premium-market-automap-configs`,
      payload,
      this.httpOptions
    );
  }

  addPremiumMarketAutoMapConfig(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/add-premium-market-automap-config`,
      payload,
      this.httpOptions
    );
  }

  editPremiumMarketAutoMapConfig(payload: any) {
    return this.http.post<any>(
      `${environment.apiUrl1}/genie-premium/edit-premium-market-automap-config`,
      payload,
      this.httpOptions
    );
  }
}